import { AppConfig } from 'shared/types/app'
import { IframeAppInstance } from 'shared/types/index'

export const transformAppConfigToAppData = (
  app: AppConfig
): IframeAppInstance => {
  return {
    id: app.id,
    icon: app.icon,
    name: app.name!,
    label: app.label,
    richAppIcon: app.richAppIcon ?? undefined,
    url: app.path,
    color: '#000',
    isPinned: app.isPinned || false
  }
}
